<template>
    <div class="pt-8">
        <FilterForm 
            :filter="filter" 
            @get-items="getItems()" 
            @clear-filter-form="clearFilterForm()" 
        />

        <ItemsTable 
            :items="items" 
            :paginator="paginator" 
            :pageSize="pageSize"  
            @get-items="getItems()" 
            @change-page="changePage($event)" 
            @open-update-modal="openUpdateModal($event)"
            @open-delete-modal="openDeleteModal($event)"
            @open-massive-import-modal="massiveImportModal = true"
            @open-search-item-modal="openSearchModal = true"
        />
        
        <ModalSearchItem
            :openSearchModal="openSearchModal" 
            :searchData="searchData" 
            @confirm-search="searchItemDetail()" 
            @close-modal="openSearchModal = false"
        />

        
        <massiveImport @close-modal="closeMassiveImportModal" @massive-import-send="massiveImportSend = true" :openModal="massiveImportModal"/>

        <AddItem 
            :openRegisterModal="itemRegisterModal" 
            :item="itemRegisterData"
            @close-modal="itemRegisterModal = false" 
            @close-add-modal="closeItemModal" 
        />
        <UpdateItem 
            :openUpdateModal="itemUpdateModal" 
            :item="itemUpdateData"
            @close-modal="itemUpdateModal = false" 
            @close-update-modal="closeItemModal" 
        />
        <DeleteItem 
            :openDeleteModal="itemDeleteModal"
            :item="itemDeleteData"
            @close-modal="itemDeleteModal = false"
            @close-delete-modal="closeItemModal"
        />
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import AddItem from '../components/RegisterItem.vue'
import UpdateItem from '../components/UpdateItemModal.vue'
import DeleteItem from '../components/DeleteItem.vue'
import massiveImport from '../components/MassiveImportPrecioPersonalizado.vue'

import FilterForm from '../components/FilterForm.vue'
import ModalSearchItem from '../components/ModalSearchItem.vue'
import ItemsTable from '../components/ItemsTable.vue'

export default {
    data(){
        return{
            items: [],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
            filter: {
                codigo: "",
            },
            searchData:{
                codigoItemSearch: ''
            },
            openSearchModal: false,
            massiveImportModal: false,
            massiveImportSend: false,
            //new
            itemUpdateModal: false,
            itemUpdateData: {},
            itemRegisterModal: false,
            itemRegisterData: {},
            itemDeleteModal: false,
            itemDeleteData: {}
        }
    },
    components: {
        AddItem,
        UpdateItem,
        DeleteItem,
        massiveImport,
        FilterForm,
        ModalSearchItem,
        ItemsTable
    },
    created(){
        this.getItems();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getItems() {
            this.pageOptions = { 
                pageNumber:   this.paginator.page, 
                pageSize:     this.paginator.pageSize,
                codigo:       this.filter.codigo,
            }
            this.setLoading(true)
            await this.$conectar.post('/precios-personalizados/get-precios-personalizados-list', this.pageOptions)
            .then(response =>{
                this.items = response.data.items;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        closeMassiveImportModal(){
            this.massiveImportModal = false;
            if(this.massiveImportSend == true){
                this.getItems();
                this.massiveImportSend = false;
            }
        },
        changePage(page){
            this.paginator.page = page;
            this.getItems();
        },
        clearFilterForm(){
            this.filter.codigo = "";
            this.paginator.pageSize = 10;
        },
        async searchItemDetail() {
            this.openSearchModal = false;
            this.pageOptions = { 
                codigo:       this.searchData.codigoItemSearch,
            }
            this.setLoading(true)
            await this.$conectar.post('/precios-personalizados/search-item-detail', this.pageOptions)
            .then(response =>{
                if(response.data.error == true){
                    this.$bvToast.toast( `${response.data.item.message} Código buscado: ${this.searchData.codigoItemSearch}`, {
                        title: "Item no encontrado",
                        variant: "warning",
                        solid: true
                    })
                }else{
                    this.openRegisterModal(response.data.item);
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast("Parece que hubo un error al conectar con el servidor", {
                    title: "Error al actualizar la solicitud",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
            this.searchData.codigoItemSearch = '';
        },
        openRegisterModal(item){
            this.itemRegisterModal = true;
            this.itemRegisterData = item;
        },
        openUpdateModal(item){
            this.itemUpdateModal = true;
            this.itemUpdateData = item;
        },
        openDeleteModal(item){
            this.itemDeleteModal = true;
            this.itemDeleteData = item;
        },
        closeModal(){
            this.itemRegisterModal = false;
            this.itemUpdateModal = false;
            this.itemDeleteModal = false;
        },
        closeItemModal(){
            this.itemUpdateModal = false;
            this.itemDeleteModal = false;
            this.itemRegisterModal = false;
            this.getItems();
        }
        
    }
}
</script>
